export default "__VITE_ASSET__DAdN_uZi__"